'use client';
import React from 'react';
import Layout from '../../components/Layout';
import PageHeader from '../../components/PageHeader';
import CompanyQuote from '../../components/CompanyQuote';
import BenefitsAndPerks from './BenefitsAndPerks';
import OpenPosition from './OpenPosition';
import WorkingWithUs from './WorkingWithUs';
import { CompanyQuoteTypeWithFooterDescription } from '../About';
import { BenifitIcon, Icon } from '../../constants/types';

interface OfficeImagesType {
  id: string;
  fluid: {
    src: string;
    alt?: string;
    aspectRatio: number;
    srcSet: string;
    sizes: string;
  };
}

interface BenefitType {
  title: string; // Keep required for component use
  description: string; // Keep required for component use
  icon: BenifitIcon
}

interface Position {
  id: string;
  title: string;
  metadata: Array<{ value: string }>;
  offices: Array<{ name: string }>;
  departments: Array<{ name: string }>;
}

interface CareersProps {
  companyQuote: CompanyQuoteTypeWithFooterDescription;
  details: {
    title: string | null | undefined;
    description: string | null | undefined;
    detailDescription: string | null | undefined;
    benefits: BenefitType[] | null;
  };
  openPositions: Position[];
  isPositionsLoading: boolean;
  officeImages?: OfficeImagesType[];
}

const Careers: React.FC<CareersProps> = ({
  companyQuote,
  details,
  openPositions,
  isPositionsLoading,
  officeImages,
}) => {
  const handleScrollToOpenPositions = () => {
    const element = document.getElementById('openPositions');
    if (element) {
      const scrollOffset = element.getBoundingClientRect().top - 50;
      window.scrollBy({ top: scrollOffset, behavior: 'smooth' });
    }
  };

  return (
    <Layout
      currentPage="/careers"
      footerDescription={companyQuote.footerDescription}
      layoutStyle={undefined}
    >
      <PageHeader
        title={details.title || ''}
        description={details.description || ''}
      />
      {/* <WorkingWithUs description={details.detailDescription} officeImages={officeImages ?? []} /> */}
      {/* <BenefitsAndPerks benefits={details.benefits || []} /> */}
      <OpenPosition openPositions={openPositions} isPositionsLoading={isPositionsLoading} />
      <CompanyQuote companyQuote={companyQuote} />
    </Layout>
  );
};

export default Careers;
